import BaseObject from '../../../../base/base_object';
import Model from './push_hybrid_model';
import {PUSH} from './push_hybrid_consts';
import {FEATURE_CB_FUNC, SERIVCES_FUNC_LIST} from "../../native/native_const";
import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';


class Push extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Push';
    _model = null;
    _HybridService = null;


    init(params) {


        super.init();

        this._model = Model.create(params);
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if(this._model.isFeatureEnable()){

            this._HybridService.isPushDeviceEnable().then(data => {
                this._model.updateEnable(this._HybridService,data);
                this._subscribe();
                this._HybridService.onDisplayWebView();
            });
        }
        return this;
    }

    _subscribe() {

        if(this._model.isEnable()){
            this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.PUSH_SET_CB, FEATURE_CB_FUNC.HYBRID_PUSH_CALL);

            Event.on(SYSTEM_EVENTS.ADD_TAG_OPEN_APP_VER, this._addTagOpenAppVer, this);
            Event.on(SYSTEM_EVENTS.ADD_TAG, this._addTag, this);
            Event.on(SYSTEM_EVENTS.REM_TAG, this._remTag, this);
            Event.on(SYSTEM_EVENTS.SUCCESSFULLY_LOGIN_RESPONSE, this._setAlias, this);

            this._addTag(PUSH.TAG_OPEN_APP);
        }
    }

    /**
     * Add Tag Open App Version - the tag will be added after the CGP will have the haybrid version
     * data example: OpenAppVer_2.6.14-0
     */

    _addTagOpenAppVer(ver){
        let data = {[PUSH.TAG]: [PUSH.TAG_OPEN_APP_VER] + '_' + ver, [PUSH.OPEN_APP_VER]:'true'};
        this._HybridService.addTag(data);
    }

    /**
     * Add Tag - the tag will be added to hybrid
     * data example: login, OpenApp, OpenAppVer_2.6.14-0
     */

    _addTag(tag) {
        let data = {[PUSH.TAG]: tag};
        this._HybridService.addTag(data);
    }

    /**
     * Remove Tag - the tag will be removed in the hybrid
     * data example: login, OpenApp
     */

    _remTag(tag) {
        let data = {[PUSH.TAG]: tag};
        this._HybridService.remTag(data);
    }

    /**
     * Set the Alias for the push
     * cidData:the Alias will be the cidData.newCid
     * data example:  {lastCid: 11111111, newCid: 22222222}
     */

    _setAlias(cidData) {
        let data = {[PUSH.ALIAS]: cidData.newCid.toString()};
        this._HybridService.setAlias(data);

        this._addTag(PUSH.TAG_LOGIN);
    }


    /**
     * check if the feature is enable
     */

    isEnable() {
        return this._model.isEnable();
    }

    /**
     * @call when app is open
     * @param data: push parames
     */
    onHybridDirectCall(data) {
        this._model.parseData(data);
        this.runAction();
    }

    /**
     * @call when app is launched
     * @param data IOS: {"error":0,"data":{"msg":"%7B%22com.urbanairship.metadata%22:%22eyJ2ZXJzaW9uX2lkIjoxLCJ0aW1lIjoxNTMyMjUwNTI4NzcwLCJwdXNoX2lkIjoiYTZlMTZjODQtMGQ4Ni00ZGFmLWEyNzAtNzkzMjBiOTkwYWNhIn0=%22,%22aps%22:%7B%22alert%22:%22Login%22,%22badge%22:1%7D,%22_%22:%22e0d14328-e61a-4d37-9905-09e8d7af34a5%22,%22action%22:%22%7B%5C%22action%5C%22:%5C%22login%5C%22%7D%22%7D"}}
     *@param data Android: "{"error":0,"data":{"msg":"%7B%22action%22%3A%7B%22action%22%3A%22login%22%7D%7D"}}"
     */
    getPushActions() {

        return new Promise((resolve, reject) => {
            this._HybridService.getPushActions().then(data => {
                this._model.parseInitData(this._HybridService,data);
                let actionData = this.runAction();
                resolve(actionData);
            }).catch(() => {
                reject();
            });
        });
    }

    /**
     * @runAction: send the event as object to the Orbit
     */

    runAction(){

        let data = this._model.getActionData();

        this._model.initData();
        if(this._model.isNullOrEmpty(data))
        {
            Event.fire(SYSTEM_EVENTS.TOUCH_ID_AUTO_LOGIN);
            return '';
        }

        try {
            Event.fire(SYSTEM_EVENTS.DEEPLINK_RECEIVED, JSON.parse(data));

        } catch (ex) {

        }
        return data;
    }
}

export default Push;
